import { render } from "./Tags.vue?vue&type=template&id=0c77e063&scoped=true&ts=true"
import script from "./Tags.vue?vue&type=script&lang=ts"
export * from "./Tags.vue?vue&type=script&lang=ts"

import "./Tags.vue?vue&type=style&index=0&id=0c77e063&scoped=true&lang=scss"

import exportComponent from "/Users/wangkaining/Code/vue_code/newapps/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c77e063"]])

export default __exports__